import { KV } from "../util";

export const Voorzieningen = ({ stats }: { stats: Record<string, number> }) => {
  const keywords = [];
  if (stats.afstand_tot_huisartsenpraktijk < 1) keywords.push("Arts");
  if (stats.ziekenhuis_excl_buitenpolikliniek_afstand_tot_ziekenhuis < 2)
    keywords.push("Ziekenhuis");
  if (stats.afstand_tot_grote_supermarkt < 1 || stats.afstand_tot_ov_dagel_levensmiddelen < 1)
    keywords.push("Boodschappen");
  if (stats.afstand_tot_warenhuis < 2) keywords.push("Winkel");
  if (stats["afstand_tot_café_ed"] < 1) keywords.push("Horeca");
  if (stats.afstand_tot_cafetaria_ed < 2 || stats.afstand_tot_restaurant)
    keywords.push("Restaurant");
  if (stats.afstand_tot_hotel_ed < 1) keywords.push("Hotel");
  if (
    stats.basisonderwijs_afstand_tot_school < 1 ||
    stats.voortgezet_onderwijs_totaal_afstand_tot_school < 1
  )
    keywords.push("School");
  if (
    stats.afstand_tot_museum < 1 ||
    stats.afstand_tot_podiumkunsten_totaal < 1 ||
    stats.afstand_tot_poppodium < 1
  )
    keywords.push("Cultuur");

  return (
    <>
      <KV k="Voorzieningen">{keywords.join(". ") || "Beperkt"}.</KV>

      {/*
afstand_tot_huisartsenpraktijk: 0.4,
afstand_tot_apotheek: 0.5,
ziekenhuis_incl_buitenpolikliniek_afstand_tot_ziekenhuis: 1.3,
ziekenhuis_excl_buitenpolikliniek_afstand_tot_ziekenhuis: 1.3,

// boodschappen
afstand_tot_grote_supermarkt: 0.3,
afstand_tot_ov_dagel_levensmiddelen: 0.1,

// winkels
afstand_tot_warenhuis: 0.9,

// horeca
afstand_tot_café_ed: 0.2,

afstand_tot_cafetaria_ed: 0.1,
afstand_tot_restaurant: 0.1,
afstand_tot_hotel_ed: 0.2,

// scholen
afstand_tot_kinderdagverblijf: 0.6,
afstand_tot_buitenschoolse_opvang: 0.6,
basisonderwijs_afstand_tot_school: 0.5,
voortgezet_onderwijs_totaal_afstand_tot_school: 0.9,
vmbo_afstand_tot_school: 1,
havo_vwo_afstand_tot_school: 0.9,

// cultuur
afstand_tot_bibliotheek: 0.8,
afstand_tot_zwembad: 2.4,
afstand_tot_museum: 0.4,
afstand_tot_podiumkunsten_totaal: 0.7,
afstand_tot_poppodium: 0.9,
afstand_tot_bioscoop: 0.7,
      */}
    </>
  );
};
